export default "__VITE_ASSET__e31bd734__"